var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFlipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0937 2.18128L16.7062 0.793775C16.1187 0.206275 15.1687 0.206275 14.5875 0.793775L2.43745 12.9375C1.84995 13.525 1.84995 14.475 2.43745 15.0563L14.5812 27.2C15.1687 27.7875 16.1187 27.7875 16.7 27.2L18.0875 25.8125C18.6812 25.2188 18.6687 24.25 18.0625 23.6688L10.5375 16.5L28.5 16.5C29.3312 16.5 30 15.8313 30 15L30 13C30 12.1688 29.3312 11.5 28.5 11.5L10.5375 11.5L18.0687 4.32502C18.6812 3.74377 18.6937 2.77503 18.0937 2.18128Z",
    fill: "#AD4D34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white",
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 0 1.39876e-06)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFlipped);
export default __webpack_public_path__ + "static/media/arrowFlipped.50d3e9a74f0c812500c1af7649eb3b49.svg";
export { ForwardRef as ReactComponent };